import { EAccountUpdateType } from '../../account';
import { ApiProperty, PickType } from '../../codegen';
import {
  Equals,
  IsBoolean,
  CustomValidatePassword,
  IsEqualTo,
  IsEnum,
  IsNotEmpty,
  IsOptional,
  IsString,
} from '../../validators';
import { BasicUser } from '../basic/basic.user.entity';

export class OnboardLoginDto extends PickType(BasicUser, ['email']) {
  @ApiProperty()
  @IsNotEmpty()
  password!: string;
}

export class OnboardRegisterDto extends PickType(BasicUser, ['email', 'name']) {
  @ApiProperty()
  @CustomValidatePassword()
  password!: string;

  @ApiProperty()
  @IsEqualTo('password')
  repeatPassword!: string;

  @ApiProperty()
  @IsBoolean()
  @Equals(true, { messageKey: 'custom.agreementRequired' })
  agreements!: boolean;

  [key: string]: unknown;
}

export class RestorePasswordDto extends PickType(BasicUser, ['email']) {
  [key: string]: unknown;
}

export class OnboardChangePasswordDto {
  @ApiProperty()
  @CustomValidatePassword()
  newPassword!: string;

  @ApiProperty()
  @IsEqualTo('newPassword')
  confirmPassword!: string;

  [key: string]: unknown;
}

export class OnboardSSELogoutReturnDto {
  @ApiProperty()
  @IsEnum(EAccountUpdateType)
  updateType: EAccountUpdateType.logout;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsString()
  keepSession?: string;
}

export class TotpCodeDto {
  @ApiProperty()
  @IsNotEmpty()
  @IsString()
  code!: string;
}
